import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer1MulczerLesny() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/mulczowanie-1.jpeg"
          alt="Mulczer leśny - mulczowanie terenu - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Mulczowanie działek pod budowę mulczerem leśnym Gdańsk, Kaszuby
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Szybkie maszynowe czyszczenie terenu z zarośli i samosiejek
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Zarośnięta działka pełna samosiejek, krzewów i wysokich traw nie musi opóźniać Twojej budowy w Gdańsku, Gdyni, Wejherowie czy Kartuzach. Oferujemy profesjonalne mulczowanie działek mulczerem leśnym, który w jeden dzień mieli zarośla na ekologiczny mulcz użyźniający glebę. To najszybsza metoda na <a href="/oczyszczanie-terenu/czyszczenie-dzialek" className="underline hover:opacity-80">oczyszczanie działek</a> pod nowe inwestycje na terenie Kaszub i całego województwa pomorskiego.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Co robi mulczer leśny
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Gdzie sprawdzi się mulczowanie terenu?
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Tereny, które oczyści mulczer leśny
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Jakie działki oczyszczamy
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Oczyszczanie działki budowlanej pod inwestycje
            </a>
            <a
              href="#6"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Co daje mulczowanie
            </a>
            <a
              href="#7"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Mulczer leśny czyli szybka wycinka samosiejek
            </a>
            <a
              href="#8"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Korzyści z zastosowania mulczera
            </a>
            <a
              href="#9"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Czy wycinka zarośli i drzew jest ekologiczna?
            </a>
            <a
              href="#10"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Wycinka samosiejek cennik – od czego zależy?
            </a>
            <a
              href="#11"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Co wpływa na koszt oczyszczenia działki?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <p>
            Mamy nowoczesny sprzęt, który szybko i sprawnie rozprawi się ze
            zbędną roślinnością na Twojej działce. Oferujemy kompleksowe usługi
            związane z oczyszczaniem działek. Nie tylko oczyścimy działkę,
            zrobimy również niwelacje terenu, a nawet zajmiemy się pracami
            ogrodowymi.
          </p>

          <p>
            Wycinamy też duże drzewa metodą klasyczną, a w razie potrzeby
            również metodą alpinistyczną. Nie musisz martwić się o pozwolenie –
            możesz zlecić to nam! W naszej ekipie pracuje dendrolog i ornitolog,
            więc mamy wszystko, co potrzebne do uzyskania pozwolenia na wycinkę.
          </p>

          <h2>Skuteczne oczyszczanie terenu z samosiejek</h2>

          <p>
            Posiadamy sprzęt, który szybko usuwa drzewa, krzaki czy zarośla.
            Nasze usługi obejmują również zrębkowanie odpadów drzewnych, czyli
            mielenie gałęzi i krzaków oraz mulczowanie działek. Rozdrobnienie
            wycinanych drzew i pozostawienie resztek na powierzchni gleby
            poprawia jej właściwości. Jest to skuteczna metoda na pozbycie się z
            działki niechcianej zieleni i wyrównanie terenu. Dzięki temu nie
            trzeba się martwić co zrobić z pozostałościami po wycince.
          </p>

          <h3 id="1">Co robi mulczer leśny</h3>
          <ul>
            <li>kosi zarośla</li>
            <li>karczuje samosiejki</li>
            <li>wycina drzewa</li>
            <li>oczyszcza teren</li>
            <li>kosi nieużytki</li>
            <li>rozdrabnia gałęzie</li>
            <li>rekultywuje działki</li>
            <li>usuwa pozostałości pozrębowe</li>
          </ul>

          <p>
            Mulczer leśny skutecznie usunie zbędną roślinność, krzewy oraz
            drzewa. Dzięki temu masz pewność, że wycięte drzewa i krzewy nie
            będą Ci już przeszkadzać. Nie ma przy tym znaczenia czy teren jest
            płaski. Oferujemy czyszczenie skarp, poboczy, rowów i wałów.
          </p>

          <p>
            Obsługujemy zarówno osoby prywatne, jak i klientów
            instytucjonalnych. Jeśli potrzebny jest Ci mulczer leśny, pomorskie
            to region, w którym działamy. Oferujemy oczyszczanie działek w
            Trójmieście i okolicach, ale nasze usługi dostępne są na całym
            Pomorzu, bo obsługujemy też Szczecin i okolice.
          </p>

          <h2 id="2">Gdzie sprawdzi się mulczowanie terenu?</h2>

          <p>
            Nasz sprzęt za pomocą specjalnego zestawu noży tnie oraz mieli
            krzaki, zarośla, a nawet całe drzewa. Jest to mulczer
            powierzchniowy. Pracuje na powierzchni ziemi zostawiając glebę
            oczyszczoną z roślinności.
          </p>

          <h3 id="3">Tereny, które oczyści mulczer leśny</h3>
          <ul>
            <li>łąki</li>
            <li>skarpy</li>
            <li>rowy melioracyjne</li>
            <li>rowy przydrożne</li>
            <li>nasypy kolejowe</li>
            <li>wały przeciwpowodziowe</li>
            <li>pasy przeciwpożarowe</li>
            <li>tereny pod farmy wiatrowe</li>
            <li>tereny przy zbiornikach wodnych</li>
          </ul>

          <p>
            Przygotujemy trasy narciarskie i sportowe. Zajmujemy się też
            kształtowaniem krajobrazu. Podejmiemy się przygotowania działek
            wielkoobszarowych pod inwestycje budowlane, drogowe czy liniowe.
            Kompleksowo przygotujemy teren pod zabudowę mieszkalną lub
            przemysłową.
          </p>

          <h3 id="4">Jakie działki oczyszczamy</h3>
          <ul>
            <li>działki rolne</li>
            <li>działki budowlane</li>
            <li>działki inwestycyjne</li>
            <li>działki siedliskowe</li>
            <li>działki leśne</li>
            <li>działki pod liniami wysokiego napięcia</li>
            <li>działki pod inwestycje drogowe</li>
            <li>działki wojskowe</li>
          </ul>

          <h2 id="5">Oczyszczanie działki budowlanej pod inwestycje</h2>

          <p>
            Po realizacji usługi działka jest gotowa pod inwestycje lub uprawy.
            Pracami ogrodowymi zajmujemy się kompleksowo, więc możemy zaoferować
            nie tylko oczyszczanie działki z drzew i krzewów, ale również
            zakładanie ogrodów.
          </p>

          <h3 id="6">Co daje mulczowanie</h3>
          <ul>
            <li>poprawia jakość gleby</li>
            <li>zmniejsza parowanie wody</li>
            <li>nie dopuszcza do rozwoju chwastów</li>
            <li>zapobiega erozji wodnej</li>
            <li>przygotowuje działkę pod uprawy lub inwestycje</li>
          </ul>

          <h2 id="7">Mulczer leśny czyli szybka wycinka samosiejek</h2>

          <p>
            Jeśli chcesz zatrudnić do porządków na działce nasz mulczer leśny,
            cena za hektar pozwoli oszacować koszt usługi. Bez problemu zrobimy
            wycenę za m2 dla mniejszych działek. Będzie to korzystniejsze cenowo
            niż ręczne wycinanie drzew i krzewów.
          </p>

          <h3 id="8">Korzyści z zastosowania mulczera</h3>
          <ul>
            <li>Wzbogaca glebę biomasą z ściętych drzew i krzewów</li>
            <li>Brak odpadów do wywiezienia po wycince</li>
            <li>Opóźnia wzrost chwastów</li>
            <li>
              Szybko usuwa niepotrzebną roślinność, która utrudnia poruszanie
              się po działce
            </li>
            <li>Jest bardzo zwrotny - może ominąć wybrane rośliny</li>
            <li>
              Zyskasz równą powierzchnię, którą będziesz mógł kosić zwykłą
              kosiarką
            </li>
          </ul>

          <p>
            Nasz mulczer leśny Bobcat T66 skutecznie usunie zbędne krzaki,
            zarośla, a nawet drzewa. Rezultatem pracy tej maszyny będzie
            doskonale oczyszczona działka.
          </p>

          <h2 id="9">Czy wycinka zarośli i drzew jest ekologiczna?</h2>

          <p>
            Według obowiązujących przepisów palenie odpadów po wycince jest
            zabronione. Grozi za to mandat. Natomiast wywóz na wysypisko będzie
            sporo kosztował.
          </p>

          <h2 id="10">Wycinka samosiejek cennik – od czego zależy?</h2>

          <h3 id="11">Co wpływa na koszt oczyszczenia działki?</h3>
          <ul>
            <li>Wielkość powierzchni do oczyszczenia</li>
            <li>Rodzaj roślin do usunięcia</li>
            <li>Rodzaj terenu</li>
            <li>Dodatkowe zanieczyszczenia</li>
            <li>Miejscowość</li>
          </ul>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[500px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/mulczowanie-2.jpeg"
              alt="Mulczowanie terenu - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[500px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/mulczowanie-3.jpeg"
              alt="Mulczowanie terenu - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
        
        
      </section>
    </>
  );
}

export default Offer1MulczerLesny;
